module.exports = __webpack_public_path__ + "static/media/suv.34de9c76.svg";